module.exports = __webpack_public_path__ + "img/re-acciona-2020.1b7277f0.jpg";